import React from 'react';
import { FaGlobe } from 'react-icons/fa';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../../i18n';
import { chooseLanguage } from '../../i18n/account';

// Navbar language picker. Each language is named in itself, so someone who cannot read the
// current language can still find their own.
export const LanguageMenu = ({ signedIn }) => {
    const { t, i18n } = useTranslation();

    const choose = async (code) => {
        if (!(await chooseLanguage(code, { signedIn }))) {
            alert(t('language.saveFailed'));
        }
    };

    return (
        <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret className="text-light" title={t('language.label')} aria-label={t('language.label')}>
                <FaGlobe /> {i18n.language.toUpperCase()}
            </DropdownToggle>
            <DropdownMenu end>
                {LANGUAGES.map(language => (
                    <DropdownItem
                        key={language.code}
                        lang={language.tag}
                        active={language.code === i18n.language}
                        onClick={() => choose(language.code)}
                    >
                        {language.name}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </UncontrolledDropdown>
    );
};
